import {FaCheckCircle} from '@assets/react-icons/fa';

export function AwesomeRoundCheckbox({checked}) {
	const offset = {top: '-15px', left: '-30px'};

	return (
		<div className='position-relative'>
			<div className='position-absolute' style={offset}>
				<i className='fa fa-circle fa-2x circle-background' />
			</div>
			<div className='position-absolute' style={offset}>
				<i className='fa fa-circle-thin fa-2x circle text-black' />
			</div>
			<div
				className='position-absolute'
				style={{
					top: '-12px',
					left: '-25px',
					display: checked ? '' : 'none'
				}}>
				<FaCheckCircle />
			</div>
		</div>
	);
}
